import React from "react";
import { Box, Typography } from "@mui/material";

const SecretCode = () => {
  return (
    <Box
      sx={{
        minHeight: "60vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        gap: 2,
        px: 2,
      }}
    >
      <Typography variant="h6" sx={{ fontWeight: 600, color: "text.secondary" }}>
        Battlepass Members Code:
      </Typography>
      <Typography variant="h3" sx={{ fontWeight: 700, color: "primary.main", letterSpacing: 4 }}>
        04/01
      </Typography>
    </Box>
  );
};

export default SecretCode;
